export default {
    navbar: {
        usdClp: {
            koywe: 'USD/CLP (Koywe): {rate}',
            manual: 'USD/CLP (manual): {rate}',
            updatedAt: 'Actualizado: {time}',
            outdated: 'Valor manual desactualizado',
            unavailable: 'USD/CLP no disponible',
        },
    },
    users: {
        actions: {
            login: 'Iniciar sesión',
            logout: 'Cerrar sesión',
            updateProfile: 'Actualizar Perfil',
        },
        fields: {
            email: 'Correo electrónico',
            // file deepcode ignore NoHardcodedPasswords: not a hardcoded password, just a translation
            password: 'Contraseña',
            newPassword: 'Contraseña Nueva',
            passwordConfirmation: 'Confirmar Contraseña',
            currentPassword: 'Contraseña Actual',
        },
        titles: {
            login: 'Iniciar sesión',
            editPassword: 'Editar Contraseña',
            editProfile: 'Editar Perfil',
        },
    },
};
